import { Component, Input } from '@angular/core';

@Component({
    selector: 'circle-shimmer',
    template: `
        <div
            fxLayout="row"
            style="overflow-y:hidden"
            fxLayoutGap="10px"
            fxLayoutAlign.gt-xs="center center"
            [ngStyle]="{ width: '100%' }"
        >
            <div *ngFor="let it of ghosts" class="circle">
                <div class="image"></div>
                <h2 [ngStyle]="{ margin: 'auto' }"></h2>
            </div>
        </div>
    `,
    styleUrls: ['./listing-circle-shimmer.component.scss'],
})
export class ListingCircleShimmerComponent {
    @Input() ghosts?: any[];
}
